import React from 'react';

const Icon = ({ icon }) => <i className={`owf owf-${icon} owf-4x`} />;

export default Icon;
